// extracted by mini-css-extract-plugin
export default {"genre-wrapper":"Filter_genre-wrapper__oEApU","genre-item":"Filter_genre-item__YNtSg","genre-active":"Filter_genre-active__sqBAV"};